/** Ein Textstueck einer Chat-Zeile: `bold` = stand zwischen `**…**`. */
export interface InlineSegment {
  text: string;
  bold: boolean;
}

const BOLD_RE = /\*\*(.+?)\*\*/g;

/**
 * Zerlegt Text mit Markdown-Fettung (`**fett**`) in Stuecke, die das Template als
 * Textknoten bzw. `<strong>` bindet. Kein HTML entsteht hier — Angular maskiert jedes
 * Stueck selbst, ein `<script>` im Text bleibt also Text (kein innerHTML noetig).
 * Hintergrund (02.11.2026): Die Karten (`app-chat-blocks`) banden Titel/Meta/Werte als
 * reinen Text; schrieb das Backend `**Lager:** 4`, standen die Sternchen sichtbar da.
 */
export function inlineBoldSegments(value: unknown): InlineSegment[] {
  if (value == null || value === '') return [];
  const s = String(value);
  const out: InlineSegment[] = [];
  let last = 0;
  for (const m of s.matchAll(BOLD_RE)) {
    const i = m.index ?? 0;
    if (i > last) out.push({ text: s.slice(last, i), bold: false });
    out.push({ text: m[1], bold: true });
    last = i + m[0].length;
  }
  if (last < s.length) out.push({ text: s.slice(last), bold: false });
  return out;
}
